export { default } from './offer.vue'
